import { Component, OnInit } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { WizardNavigationComponent } from '../../../../shared/components/wizard-navigation/wizard-navigation.component';
import { WorkHistoryService, WorkHistory } from '../../services/work-history.service';
import { LinkCellComponent, TableColumn, TableComponent } from 'ddmo-storybook-lib';
import { MatTableDataSource } from '@angular/material/table';
import { ElementRef, Renderer2, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ConfirmationPopupComponent } from '../../../popups/processing/processing.component';
import { MatDialog } from '@angular/material/dialog';


@Component({
  selector: 'app-work-history',
  imports: [CommonModule, FormsModule, WizardNavigationComponent, TableComponent],
  templateUrl: './work-history.component.html',
  styleUrl: './work-history.component.scss'
})
export class WorkHistoryComponent implements OnInit {
  workHistories: WorkHistory[] = [];
  warehouseList: any = [];
  workHistoryList: any = [];
  @ViewChild('tableWrapper', { static: false }) tableWrapper!: ElementRef<HTMLElement>;
  public dataSource = new MatTableDataSource<any>([]);
  public tableColumns: TableColumn[] = [];
  private datepipe = new DatePipe('en-US')
  impersonatedUser: any = localStorage.getItem("impersonatedUser") ?? ""
  constructor(
    private router: Router,
    private workHistoryService: WorkHistoryService,
    private renderer: Renderer2, public dialog: MatDialog
  ) { }

  ngOnInit() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.workHistoryService.workHistories$.subscribe(histories => {
      this.workHistories = histories;
    });

    this.workHistoryService.workHistories$.subscribe(list => {
      this.warehouseList = JSON.parse(localStorage.getItem('warehouseworkhistories') || '[]');
      this.workHistoryList = JSON.parse(localStorage.getItem('workhistories') || '[]');

      this.warehouseList = this.warehouseList.filter((item: any) => item.organizationName && item.organizationName.trim() != '');
      this.workHistoryList = this.workHistoryList.filter((item: any) => item.organizationName && item.organizationName.trim() != '');
      let updatedList = this.mergeWarehouseList(this.workHistoryList, this.warehouseList);
      updatedList = updatedList.map((item: any) => ({
        ...item,
        organizationName: item.organizationName === 'My School Is Not Listed'
        ? item.other
        : item.organizationName,
        startDate: item.startDate ? this.datepipe.transform(item.startDate, 'MM-dd-yyyy') : null,
        endDate: item.endDate ? this.datepipe.transform(item.endDate, 'MM-dd-yyyy') : null,
      }))
      this.dataSource.data = this.workHistoryService.sortByDate(updatedList);
      this.setUpColumns();
    })
  }
  private setUpColumns() {
    const baseColumns: TableColumn[] = [
      {
        columnId: 'organizationName',
        columnLabel: 'Work/school',
        sort: false,
        headerData: null,
        columnData: null,
        caseInsensitive: false
      },
      {
        columnId: 'startDate',
        columnLabel: 'Start date',
        sort: false,
        headerData: null,
        columnData: null,
        caseInsensitive: false
      },
      {
        columnId: 'endDate',
        columnLabel: 'End date',
        sort: false,
        headerData: null,
        columnData: null,
        caseInsensitive: false
      }
    ];

    const hasEditableRows = this.dataSource.data.some((item: any) => !item.isLocationInDW);
    if (hasEditableRows) {
      baseColumns.push({
        columnId: 'action',
        columnLabel: '',
        sort: false,
        headerData: null,
        columnData: {
          cellType: LinkCellComponent,
          data: {
            label: 'Edit',
            actionData: 'workHistoryId',
          },
          otherParams: 'edit'
        },
        caseInsensitive: false,
      });
    }

    if (hasEditableRows && !this.impersonatedUser) {
      baseColumns.push({
        columnId: 'delete',
        columnLabel: '',
        sort: false,
        headerData: null,
        columnData: {
          cellType: LinkCellComponent,
          data: {
            label: 'Delete',
            actionData: 'workHistoryId',
          },
          otherParams: 'delete'
        },
        caseInsensitive: false,
      });
    }

    this.tableColumns = baseColumns;
  }
  ngAfterViewChecked(): void {
    this.addDeleteIconClass()
  }
  onTableClick(event: any) {
    if (!event) return;
    const id = event.data;
    const row = event.row;
    if (row?.isLocationInDW && event.otherParams == 'delete') {
      return;
    }
    if (row?.isLocationInDW && event.otherParams == 'edit') {
      return;
    }
    if (event.otherParams == 'delete') {
      this.deleteHistory(id);
    }
    else {
      this.editHistory(id);
    }
  }
  canAddMore(): boolean {
    return this.dataSource.data.length < 5;
  }

  addMoreHistory() {
    if (this.canAddMore()) {
      this.router.navigate(['/credentialing/work-history/add']);
    }
  }

  editHistory(id: string) {
    this.router.navigate(['/credentialing/work-history/edit', id]);
  }

  deleteHistory(id: string) {
    let alertMessage = `Are you sure you want to delete this work history`;
    let dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      data: { message: alertMessage, isWHDeletion: true },
      width: '550px',
      backdropClass: '',
      hasBackdrop: true,
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result == true) {
        this.workHistoryService.deleteWorkHistory(id).subscribe({
          next: (res) => {
          },
          error: (err) => {
            if (err.status === 404) {
              this.dataSource.data = this.warehouseList;
              localStorage.setItem('workhistories', JSON.stringify([]));
              this.workHistoryService.reloadFromStorage();
            }
          }
        })
      }
    });
  }

  onBack() {
    this.router.navigate(['/credentialing/credentials']);
  }

  onNext() {
    this.router.navigate(['/credentialing/attestations']);
  }
  onCancel() {
    this.router.navigate(['/landing']);
  }
  private addDeleteIconClass(): void {

    if (this.tableWrapper) {
      const deleteLinks: any = this.tableWrapper.nativeElement.querySelectorAll(
        '[aria-label="Delete"]'
      );
      const editLinks: any = this.tableWrapper.nativeElement.querySelectorAll(
        '[aria-label="Edit"]'
      );
      editLinks.forEach((link: HTMLElement, index: number) => {
        const row = this.dataSource.data[index];

        if (row?.isLocationInDW) {
          link.style.display = 'none'
          return;
        }
      })
      deleteLinks.forEach((link: HTMLElement, index: number) => {
        const row = this.dataSource.data[index];

        if (row?.isLocationInDW) {
          link.style.display = 'none'
          return;
        }
        if (link.querySelector('.delete-icon')) {
          return;

        }
        if (!link.classList.contains('material-icons')) {
          this.renderer.addClass(link, 'material-icons');
        }
        this.renderer.addClass(link, 'delete-action')
        link.innerHTML = '';
        const svg = this.renderer.createElement('svg', 'svg');

        this.renderer.setAttribute(svg, 'xmlns', 'http://www.w3.org/2000/svg');
        this.renderer.setAttribute(svg, 'width', '22');
        this.renderer.setAttribute(svg, 'height', '22');
        this.renderer.setAttribute(svg, 'viewBox', '0 0 24 24');
        this.renderer.setAttribute(svg, 'fill', 'none');
        this.renderer.setAttribute(svg, 'stroke', 'currentColor');
        this.renderer.addClass(svg, 'delete-icon');

        svg.innerHTML = `
        <polyline points="3 6 5 6 21 6"></polyline>
        <path d="M19 6l-1 14H6L5 6"></path>
        <path d="M10 11v6"></path>
        <path d="M14 11v6"></path>
        <path d="M9 6V4h6v2"></path>
      `;

        this.renderer.appendChild(link, svg);

      });
    }
  }
  toDate(yyyymmdd: string): Date {
    const year = Number(yyyymmdd.substring(0, 4));
    const month = Number(yyyymmdd.substring(4, 6)) - 1;
    const day = Number(yyyymmdd.substring(6, 8));

    return new Date(year, month, day);
  }
mergeWarehouseList(workHistoryList: any[], warehouseList: any[]) {

  const filteredWorkHistory = workHistoryList.filter(history =>
    !warehouseList.some(warehouse =>
      this.normalizeValue(history.organizationName) === this.normalizeValue(warehouse.organizationName) &&
      this.normalizeValue(history.address1) === this.normalizeValue(warehouse.address1) &&
      this.normalizeValue(history.city) === this.normalizeValue(warehouse.city) &&
      this.normalizeValue(history.state) === this.normalizeValue(warehouse.state) &&
      this.normalizeValue(history.zip) === this.normalizeValue(warehouse.zip) &&
      this.normalizeDate(history.endDate) === this.normalizeDate(warehouse.endDate)
    )
  );

  const work = filteredWorkHistory.map(item => ({
    ...item,
    isLocationInDW: false
  }));

  const warehouse = warehouseList.map(item => ({
    ...item,
    endDate: this.convertDWDate(item.endDate),
    startDate: this.convertDWDate(item.startDate),
    isLocationInDW: true
  }));

  return [...work, ...warehouse];
}

normalizeValue(val: any): string {
  return (val ?? '').toString().trim();
}


normalizeDate(date: any) {

  if (!date) return null;

  const d = date.toString();

  if (d.length === 8 && !d.includes('-')) {
    const year = d.substring(0,4);
    const month = d.substring(4,6);
    const day = d.substring(6,8);
    return `${year}-${month}-${day}`;
  }

  return d;
}

convertDWDate(date: any) {
  if (!date) return null;

  const d = date.toString();

  if (d.length === 8) {
    const year = d.substring(0, 4);
    const month = d.substring(4, 6);
    const day = d.substring(6, 8);
    return `${year}-${month}-${day}`;
  }

  return date;
}


}
